import Vue from 'vue'
import adjustmentTransformer from '@/transformers/catalog/warehouse/adjustment'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new adjustment output 
 * @param newAdjustment New adjustment output object
 * @return {object}
 */

export default (newAdjustment, warehouseId) => {
  const payload = adjustmentTransformer.sendOutput(newAdjustment)
  return Vue.$http.post(`iwarehouse/movement/${warehouseId}/output-by-adjustment/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/adjustmentOutput.js